import { Link } from "react-router-dom";
import { PALETTE, FONT_BODY, FONT_DISPLAY, FONT_MONO, track } from "./tokens";
import { ArrowRight, Check } from "./icons";
import { OFFER } from "@/lib/offer";

/* CoBrain package card — engineer-led model. No self-serve checkout:
   CoBrain is deployed as part of the engagement and scoped on a call.
   Prop shape kept for compatibility with CoBrain.tsx. */

type Props = {
  onReserve: () => void;
  onCheckout?: (seats: number) => unknown;
  employees?: number;
  onEmployeesChange?: (n: number) => void;
};

const INCLUDES = [
  "Company brain across every employee",
  "An engineer who learns how your company runs",
  "Email + CRM + calendar + docs integration",
  "Per-agent permissions & owner approval gates",
  "Watchtower across the whole company",
  "Reusable shared skills across agents",
  "Hosting, security & staff training",
  "Eva as the owner's seat inside the brain",
];

export const EmployeeSliderPricing = ({ onReserve }: Props) => (
  <div data-pricing-card style={{
    background: PALETTE.dark, color: "#fff", borderRadius: 24,
    padding: "clamp(20px, 5vw, 48px)", position: "relative", overflow: "hidden",
    boxShadow: "0 30px 60px -30px rgba(0,0,0,0.4)",
  }}>
    <div aria-hidden style={{
      position: "absolute", inset: "-30% -10% auto auto", width: 480, height: 480,
      background: `radial-gradient(circle, ${PALETTE.amber}33 0%, transparent 60%)`,
      filter: "blur(40px)", pointerEvents: "none",
    }} />
    <div style={{ position: "relative", zIndex: 1 }}>
      <div style={{ fontSize: 11, letterSpacing: "0.16em", textTransform: "uppercase", color: PALETTE.amberSoft, fontWeight: 700, fontFamily: FONT_MONO, marginBottom: 16 }}>
        CoBrain · part of your deployment
      </div>
      <div style={{ display: "flex", alignItems: "baseline", gap: 10, flexWrap: "wrap", marginBottom: 12 }}>
        <span style={{ fontSize: 15, color: "rgba(255,255,255,0.6)" }}>Engagements from</span>
        <span style={{ fontFamily: FONT_DISPLAY, fontStyle: "italic", fontSize: "clamp(48px, 7vw, 72px)", lineHeight: 1 }}>{OFFER.startingPrice}</span>
        <span style={{ fontSize: 16, color: "rgba(255,255,255,0.6)" }}>/ month</span>
      </div>
      <p style={{ fontSize: 15, color: "rgba(255,255,255,0.78)", margin: "8px 0 28px", maxWidth: 620, lineHeight: 1.55 }}>
        Scoped on a call to your team size and workflows. Your engineer gets CoBrain and Eva live in days, then keeps expanding them.
      </p>
      <ul style={{ listStyle: "none", padding: 0, margin: "0 0 32px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 12 }}>
        {INCLUDES.map((f) => (
          <li key={f} style={{ display: "flex", alignItems: "flex-start", gap: 10, fontSize: 14.5, color: "rgba(255,255,255,0.88)" }}>
            <Check size={14} color={PALETTE.amberSoft} />
            <span>{f}</span>
          </li>
        ))}
      </ul>
      <div data-inline-cta style={{ display: "flex", flexWrap: "wrap", gap: 12, alignItems: "center" }}>
        <button type="button" onClick={() => { track("package_talk_click"); onReserve(); }} style={{
          display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8,
          padding: "14px 26px", background: PALETTE.amber, color: "#fff",
          borderRadius: 999, border: 0, fontSize: 14, fontWeight: 600, minHeight: 48, cursor: "pointer",
          fontFamily: FONT_BODY, boxShadow: "0 12px 32px -10px rgba(196,130,58,0.55)",
        }}>
          Talk to an engineer <ArrowRight size={15} />
        </button>
      </div>
      <p style={{ marginTop: 28, fontSize: 12.5, color: "rgba(255,255,255,0.55)", lineHeight: 1.55, maxWidth: 620 }}>
        <span style={{ color: PALETTE.amberSoft, fontWeight: 700 }}>Just the owner?</span>{" "}
        <Link to="/#pricing" style={{ color: PALETTE.amberSoft, textDecoration: "underline" }}>Start with Eva →</Link>
      </p>
    </div>
  </div>
);
